import { render, staticRenderFns } from "./newForm.vue?vue&type=template&id=2d763915&scoped=true&"
import script from "./newForm.vue?vue&type=script&lang=js&"
export * from "./newForm.vue?vue&type=script&lang=js&"
import style0 from "./newForm.vue?vue&type=style&index=0&id=2d763915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d763915",
  null
  
)

export default component.exports